<template>
  <header>
    <div class="head wrap flex flex-center flex-between">
      <h1 class="logo">
        <a href="" class="logo flex flex-center"
          ><img src="~@/assets/images/logo.png" alt="" />
          江苏省产品质量监督检验研究院
        </a>
      </h1>
      <form action="" class="coop flex flex-center">
        <div class="keywords">
          <div class="input-addon">检索 :</div>
          <div class="divider"></div>
          <input v-model="keywords" type="text" />
        </div>
        <div class="column H_dropdown">
          <div class="select H-select-sel">
            {{ selectedName }}
            <ul class="H-dropdown-option">
              <li
                v-for="item in optionsList"
                :key="item.id"
                @click="changeCloumn(item)"
              >
                {{ item.name }}
              </li>
            </ul>
          </div>
          <!-- <select v-model="selected">
            <option disabled value="">选择栏目</option>
            <option v-for="item in optionsList" :key="item.id" :value="item.id">
              {{ item.name }}
            </option>
          </select> -->
        </div>
        <div class="search" @click="search">
          <img src="~@/assets/images/search.png" style="width: 15px" alt="" />
        </div>
      </form>

      <div class="m-menu">
        <el-button
          icon="el-icon-s-operation"
          size="mini"
          plain
          @click="openDrawer"
        ></el-button>
      </div>
    </div>

    <el-drawer :visible.sync="drawer" direction="rtl" size="100%">
      <ul class="m-nav">
        <!-- <li><router-link to="/">首页</router-link></li> -->
        <li><a href="javascipt:;" @click="goHome">首页</a></li>
        <li
          v-for="(item, index) in routerList"
          :key="item.id"
          :class="item.subSet && item.subSet.length > 0 ? 'isDrop' : ''"
        >
          <a
            href="javascript:;"
            v-if="!item.isLink"
            @click.prevent="goRouter(item.url, item.id)"
            class="flex flex-center flex-between"
            >{{ item.name }}
            <i
              v-if="item.subSet && item.subSet.length > 0"
              @click.stop="shouSubnav(item)"
              class="el-icon-arrow-down"
            ></i
          ></a>
          <a
            href="javascript:;"
            v-else
            @click="goRouter3(item.url)"
            class="flex flex-center flex-between"
            >{{ item.name }}
            <i
              v-if="item.subSet && item.subSet.length > 0"
              @click.stop="shouSubnav(item)"
              class="el-icon-arrow-down"
            ></i
          ></a>

          <ul
            class="subnav"
            :ref="'subnav' + index"
            v-if="item.subSet && item.subSet.length > 0 && item.toggle"
          >
            <li v-for="(item2, index2) in item.subSet" :key="item2.id">
              <a
                href="javascript:;"
                v-if="!item2.isLink"
                @click="goRouter2(item.url, item2.id, item.id)"
                >{{ item2.name }}</a
              >
              <a href="javascript:;" v-else @click="goRouter3(item2.url)">{{
                item2.name
              }}</a>
            </li>
          </ul>
        </li>
      </ul>
    </el-drawer>
  </header>
</template>

<script>
import $ from "jquery";

export default {
  data() {
    return {
      drawer: false,
      optionsList: [],
      selected: "",
      keywords: "",
      routerList: [],
      selectedName: "选择栏目",
    };
  },
  methods: {
    goHome() {
      this.$router.push("/");
      this.drawer = false;
    },
    goRouter(url, id) {
      if (url.includes("sybh")) {
        this.$router.push({
          path: `${url}`,
        });
      } else {
        this.$router.push({
          path: `${url}/${id}`,
        });
        localStorage.setItem("pId", id);
      }
      this.drawer = false;
    },
    goRouter2(url, id, ids) {
      this.$router.push({
        path: `${url}/${id}`,
      });
      localStorage.setItem("pId", ids);
      this.drawer = false;
    },
    goRouter3(url) {
      const urls = this.$router.resolve({
        path: `${url}`,
      }).href;
      window.open(urls, "_blank");
      this.drawer = false;
    },
    openDrawer() {
      this.drawer = true;
      if (this.routerList.length == 0) {
        this.getNavList();
      }
    },
    // 下拉
    getOptions() {
      this.$request("/web/getHomeOptions", "GET").then((res) => {
        this.optionsList = res.data.data;
      });
    },
    getNavList() {
      this.$request("/web/getNav", "GET").then((res) => {
        this.routerList = res.data.data.map((item) => {
          return { ...item, toggle: false };
        });
      });
    },
    search() {
      if (this.keywords.trim() == "") {
        this.$message({
          message: "搜索栏关键字不能为空",
          type: "warning",
        });
        return;
      }
      this.$router
        .replace({
          path: "/getSearch",
          query: {
            keywords: this.keywords,
            id: this.selected,
          },
        })
        .catch((err) => {});
    },
    shouSubnav(item) {
      item.toggle = !item.toggle;
    },
    changeCloumn(item) {
      this.selected = item.id;
      this.selectedName = item.name;
    },
  },
  mounted() {
    this.getOptions();

    $(function () {
      $(".H_dropdown").each(function () {
        var _this = $(this);
        var $sel = _this.find(".H-select-sel");
        var $option = _this.find(".H-dropdown-option");

        $sel.click(function (e) {
          e.stopPropagation();
          $option.toggle();
        });

        const excludeElement = document.getElementById("toggle");
        $(document).click(function (event) {
          if (
            excludeElement &&
            (event.target === excludeElement ||
              excludeElement.contains(event.target))
          ) {
            // 如果是排除的元素，不执行任何操作
            return;
          } else {
            $option.hide();
          }
        });
      });
    });
  },
};
</script>

<style lang="less" scoped>
header {
  background-color: rgba(21, 98, 157, 1);
  // padding: 7px 0 8px !important;
  height: 60px;
  .head {
    height: 100%;
  }
  .logo {
    height: 56px;
    color: #fff;
    font-weight: bold;
    font-size: 20px;
    img {
      margin-right: 10px;
    }
  }

  .coop {
    > div {
      height: 30px;
      border: 1px solid #21649f;
      border-radius: 4px;
      background-color: #87b5df;
      display: flex;
      align-items: center;
      font-size: 14px;
      color: rgba(255, 255, 255, 0.6);
    }

    .keywords {
      padding: 0 14px;

      .divider {
        width: 1px;
        height: 22px;
        background-color: #6498ce;
        margin: 0 8px;
      }

      input {
        color: rgba(255, 255, 255, 0.6);
      }
    }

    .column {
      margin: 0 10px;

      .select {
        position: relative;
        background-color: transparent;
        border: none;
        width: 100px;
        height: 100%;
        color: rgba(255, 255, 255, 0.6);
        padding: 0 10px;
        line-height: 28px;
        cursor: pointer;

        // option {
        //   line-height: 32px;
        //   color: #000;
        // }
        ul {
          position: absolute;
          left: 0;
          top: 100%;
          display: none;
          background-color: #87b5df;
          width: 100%;
          border: 1px solid #21649f;
          line-height: 32px;
          font-size: 14px;
          color: rgba(255, 255, 255, 0.6);
          z-index: 99999;
          li {
            padding-left: 10px;
            cursor: pointer;
          }
        }
      }
    }

    .search {
      width: 40px;
      text-align: center;
      justify-content: center;
      cursor: pointer;
    }
  }

  .m-menu {
    display: none;
  }
}

/deep/.el-drawer {
  background: #357ebd !important;
  color: #fff !important;
  .el-drawer__close-btn {
    color: #fff;
  }
}

@media screen and (max-width: 998px) {
  .m-menu {
    display: block !important;
  }

  .m-nav {
    padding: 0 20px;
    li {
      margin: 20px 0;

      .subnav {
        padding-left: 10px;
      }
    }
  }
}
</style>